import React, { useState, useEffect, useRef } from "react";
import WITHDRAWN_IMAGE from "../../../images/Banner/withdrawn.jpg";
import useMediaQuery from "@mui/material/useMediaQuery";
import { nextAuction, getLotByAll } from "../../Model/Auction";
import NoImage from "../../images/resources/noImage.jpg";
import Backdrop from "@mui/material/Backdrop";
import { getUser } from "../../Model/LocalStorage";
import { storeAllLots, getAllLots } from "../../../Model/LocalStorage";
import { Box, Typography } from "@mui/material";

import { LotListItem } from "./components/LotItems";
import { LotPreviewDialog } from "./components/LotDialogs";
import { AnnouncementPanel } from "./components/RoomSections";
import { FONT, R, labelSx, thinScrollSx } from "./components/roomTheme";

/*
 * Desktop lot list (left column): auction name, announcement, all lots with the current
 * lot highlighted and scrolled into view, and a zoomable preview of any lot.
 *
 * UNCHANGED: loading the lots (getLotByAll + storeAllLots), the "receive_status"
 * NEXTSLOT / PASS handler that loads the next lot (nextAuction), the
 * "receiveAnnouncement" listener, the auto-scroll and the zoom / pan state.
 * Removed: the unused decrement() (previous lot) function and unused imports.
 */

export default function ListImage({
  socket,
  details,
  lotNumber,
  mediadQuery,
  titleAuction,
}) {
  const [getData, setGetData] = useState([]);
  const [count, setCount] = useState(0);
  const phoneMatch = useMediaQuery("(min-width:1200px)");
  const [loading, setLoading] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [image, setImage] = React.useState("");
  const [title, setTitle] = React.useState("");
  const [artist, setArtist] = React.useState("");
  const [lot_Number, setLotnumber] = React.useState("");
  const [, setHp] = React.useState("");
  const [announcement, setAnnouncement] = useState("");
  const [status, setStatus] = useState("");
  const [hammerPrice, setHammerPrice] = useState("");
  const currentLotRef = useRef(null);
  const listContainerRef = useRef(null);
  const [withdrawn, setWithdrawn] = React.useState(0);
  const [userId, setUserId] = useState("");
  const [userBid, setUserBid] = useState("");


  const handleClickOpen = (row) => {
    setUserBid(row.data.userBid)
    setWithdrawn(row.data.isWithdrawn)
    setImage(row.images[0].img_url);
    setTitle(row.data.title);
    setArtist(row.data.artist);
    setLotnumber(row.data.lot_number);
    setHp(row.data.starting_price);
    setStatus(row.data.lot_status)
    setHammerPrice(row.data.hp)
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  function increment(lotNo) {
    setLoading(true);
    try {
      async function getNextAuction() {
        const ArrayData = {
          auction_id: details.auction_details.auction_id,
          setId: details.auction_details.id,
          LotNo: lotNo,
        };
  
        const results = await nextAuction(ArrayData);
        setLoading(false);
  
        if (results.success === false) {
          return;
        }
  
        setGetData((prev) => [...prev, ...results]); // Append data
      }
  
      getNextAuction().catch(() => setLoading(false));
    } catch (error) {
      setLoading(false);
    }
  }

  // 🔁 This stays the same
const listImage = () => {
  const getNextAuction = async () => {
    try {
      const ArrayData = {
        auction_id: details?.auction_details?.auction_id,
        setId: details?.auction_details?.id,
        LotNo: lotNumber + 1,
      };

      const results = await getLotByAll(ArrayData);

      if (!results || results.success === false) {
        setGetData([]);
      } else {
        storeAllLots(results.msg);
        setGetData(results.msg);
      }
    } catch (error) {
      console.error("getNextAuction error:", error);
      setGetData([]);
      setLoading(false);
    }
  };

  getNextAuction();
};



  useEffect(() => {
    if (!details || !socket) return;
  
    // 👇 Only call listImage when details are ready

    // Set initial lot
    setCount(lotNumber + 1);
  
    // Announcement
    const announcementText = details?.announcement?.[0]?.announcement || "";
    setAnnouncement(announcementText);
  
    // Socket Handlers
    const handleStatus = (data) => {
      try {
        const { message, nextCount } = data;
        console.log(data);
  
        if (message === "NEXTSLOT" || message === "PASS") {
          const nextLot = parseInt(nextCount) + 2;
          increment(nextLot);
          setCount(nextLot);
        }
      } catch (error) {
        console.error("Error handling socket data:", error);
      }
    };
  
    const handleAnnouncement = (data) => setAnnouncement(data.message);
  
    socket.on("receiveAnnouncement", handleAnnouncement);
    socket.on("receive_status", handleStatus);
  
    return () => {
      socket.off("receiveAnnouncement", handleAnnouncement);
      socket.off("receive_status", handleStatus);
    };
  }, [socket, details, lotNumber, mediadQuery]);

  

 
 useEffect(() => {
  listImage();
  

  const getUserList = async () => {
    try {
      const user = await getUser();
      if (user) {

        setUserId(user.id);
  
      }
    } catch (err) {
      console.error("Failed to get user:", err);
    }
  };
  
  getUserList();


  const getLotsAll = async () => {
    try {
      const result = await getAllLots();

      if (!result || result === "no record found") {
        console.warn("No lots found");
        // ⛔ Don't call listImage here again, it's already handled above
        return;
      }

    } catch (error) {
      console.error("Error fetching lots:", error);
    }
  };

  getLotsAll();
}, [getAllLots]);




  useEffect(() => {
    if (currentLotRef.current && listContainerRef.current) {
      const container = listContainerRef.current;
      const item = currentLotRef.current;

      const containerTop = container.getBoundingClientRect().top;
      const itemTop = item.getBoundingClientRect().top;

      const scrollOffset = itemTop - containerTop;

      container.scrollTo({
        top: container.scrollTop + scrollOffset,
        behavior: "smooth",
      });
    }
  }, [count, getData]);

  const [zoomLevel, setZoomLevel] = useState(1);
  const [offset, setOffset] = useState({ x: 0, y: 0 });
  const [isDragging, setIsDragging] = useState(false);
  const [startPos, setStartPos] = useState({ x: 0, y: 0 });

  
  const handleZoomIn = () =>
  setZoomLevel((prev) => {
    const next = prev + 0.2;
    return next > 3 ? 3 : parseFloat(next.toFixed(1));
  });

const handleZoomOut = () =>
  setZoomLevel((prev) => {
    const next = prev - 0.2;
    return next < 1 ? 1 : parseFloat(next.toFixed(1));
  });

  const handleMouseDown = (e) => {
    setIsDragging(true);
    setStartPos({ x: e.clientX - offset.x, y: e.clientY - offset.y });
  };
  
  const handleMouseMove = (e) => {
    if (!isDragging) return;
    setOffset({
      x: e.clientX - startPos.x,
      y: e.clientY - startPos.y,
    });
  };
  
  const handleMouseUp = () => setIsDragging(false);
  useEffect(() => {
    if (open) {
      setOffset({ x: 0, y: 0 });
      setZoomLevel(1);
    }
  }, [open]);
  

  const zoom = {
    level: zoomLevel,
    offset,
    dragging: isDragging,
    onMouseDown: handleMouseDown,
    onMouseMove: handleMouseMove,
    onMouseUp: handleMouseUp,
    onZoomIn: handleZoomIn,
    onZoomOut: handleZoomOut,
  };

  return (
    <Box sx={{ fontFamily: FONT }}>
    

      {announcement && (
        <Box sx={{ px: 1.5, pt: 1.5, display: mediadQuery === false ? "none" : "block" }}>
          <AnnouncementPanel text={announcement} maxHeight={120} />
        </Box>
      )}

      <Box sx={{ px: 1.5, pt: 1.5, pb: 0.75, borderBottom: `1px solid ${R.ink}` }}>
        <Typography component="h2" sx={{ ...labelSx, color: R.ink }}>
          Lots
        </Typography>
      </Box>

      <Box
        ref={listContainerRef}
        component="ul"
        sx={{
          listStyle: "none",
          m: 0,
          p: 0,
          // ≥ 1200px the whole lot column scrolls; below that the list sits under the artwork.
          maxHeight: phoneMatch === true ? "none" : 320,
          minHeight: 160,
          overflowY: "auto",
          ...thinScrollSx,
        }}
      >
        {Array.isArray(getData) && getData.length > 0 ? (
          getData.map((row, i) => {
            if (!row || !row.data) return null;

            const lot = row.data;
            const image = row.images?.[0]?.img_url ?? null;
            const isCurrent = parseInt(lot.lot_number) === parseInt(lotNumber);

            return (
              <LotListItem
                key={i}
                ref={isCurrent ? currentLotRef : null}
                current={isCurrent}
                onClick={(e) => handleClickOpen(row)}
                image={image === null ? NoImage : lot.isWithdrawn === 1 ? WITHDRAWN_IMAGE : image}
                primaryHtml={lot.lot_number + ". " + (lot.artist === null ? lot.title : lot.artist)}
                secondaryHtml={lot.artist === null ? null : lot.title === null ? lot.artist : lot.title}
                status={lot.lot_status}
                soldPrice={lot.lot_status === "SOLD" ? "₱ " + lot.hp.toLocaleString() : null}
                soldColor={lot.userBid === userId ? R.success : R.ink}
              />
            );
          })
        ) : (
          <Typography component="li" sx={{ fontFamily: FONT, color: R.secondary, textAlign: "center", py: 6 }}>
            No Data
          </Typography>
        )}
      </Box>

      <LotPreviewDialog
        open={open}
        onClose={handleClose}
        image={withdrawn === 1 ? WITHDRAWN_IMAGE : image || "https://placehold.co/450x274?text=NO%20IMAGE"}
        lotNumber={lot_Number}
        withdrawn={withdrawn}
        artist={artist}
        title={title}
        soldPrice={status === "SOLD" ? "₱ " + parseFloat(hammerPrice).toLocaleString() : null}
        soldColor={userBid === userId ? R.success : R.danger}
        zoom={zoom}
      />

      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <Typography sx={{ fontFamily: FONT, letterSpacing: "2px" }}>Loading…</Typography>
      </Backdrop>
    </Box>
  );
}
